import { useEffect, useState} from 'react';
import { SxProps, Box, Theme} from '@mui/material';
import useExtensions from './useExtensions';
import './ARichTextReadOnly.css';


import {
    RichTextReadOnly
} from 'mui-tiptap';

export interface Props {
    placeholder?: string,
    content?: string,
    sx?: SxProps<Theme>
    className?: string;
    noBorder?: boolean;
}

export default function ARichTextReadOnly({placeholder,
    content, sx, className, noBorder}: Props){

    const extensions = useExtensions({
            placeholder: placeholder??''
    });
    
    const [htmlContent, setHtmlContent] = useState<string>('');

    useEffect(() => {
        if (content) {
            const lines = content.split('\n').map(x => x.trimEnd());
            const htmlLines = lines.map(x => x.startsWith('<') ? x : `<p>${x}</p>`);
            const newContent = htmlLines.join('\n');
            setHtmlContent(newContent);
        } else {
            setHtmlContent('');
        }
    }, [content]);
    
    return (
        <div style={{height: '100%'}}>
            <Box
                sx={{
                    minHeight: className && className === 'mini' ? '30px' : '250px',
                    maxHeight: className && className === 'mini' ? '280px' : undefined,
                    height: '100%',
                    //outlineStyle: 'solid',
                    //outlineWidth: 'thin',
                    padding: '12px',
                    border: noBorder ? undefined : '1px solid rgba(0, 0, 0, 0.12)',
                    // An example of how editor styles can be overridden. In this case,
                    // setting where the scroll anchors to when jumping to headings. The
                    // scroll margin isn't built in since it will likely vary depending on
                    // where the editor itself is rendered (e.g. if there's a sticky nav
                    // bar on your site).
                    '& .ProseMirror': {
                        '& h1, & h2, & h3, & h4, & h5, & h6': {
                            scrollMarginTop: 50,
                        }
                    },
                ...sx}}
            >
            <RichTextReadOnly
                content={htmlContent}
                extensions={extensions}
                
            />
            </Box>
        </div>
    );
}
